// extracted by mini-css-extract-plugin
export var emailBlockLink = "_hl-0";